import PropTypes from 'prop-types';
import { useSnackbar } from "notistack";
import { makeStyles } from '@material-ui/core/styles';
import React, { useState, useEffect, useRef } from "react";
import { Button, DialogActions, DialogContent } from "@material-ui/core";

import CreatedBy from './CreatedBy.js';
import Exercicio from './Exercicio.js';
import api from "../../../../../services/api.js";

const useStyles = makeStyles((theme) => ({
    root: {
        '& .MuiTextField-root': {
            margin: theme.spacing(1),
            width: '25ch',
        },
    },
}));

export default function FormStore(props) {
    const {
        data,
        setOpen,
        setReload,
    } = props;

    const classes = useStyles();

    const snack = useRef()
    const { enqueueSnackbar } = useSnackbar();
    snack.current = enqueueSnackbar

    const [values, setValues] = useState({
        funcao: '',
        exercicio: '',
        idFuncao: '',
        criado_em: '',
        criado_por: '',
        editado_em: '',
        editado_por: '',
    });

    const [responsaveis, setResponsaveis] = useState([{ value: '', label: '' }])
    const [user_exercicio, setUserExercio] = useState({
        'idFuncao': "",
        'userIdExercicio': ""
    })

    useEffect(() => {
        if (data) {
            let responsaveis = [{ value: "", label: "" }]
            for (let cont in data.responsaveis) {
                let aux = {
                    value: data.responsaveis_id[cont],
                    label: data.responsaveis[cont]
                }
                responsaveis.push(aux)
            }
            setResponsaveis(responsaveis)
            setValues(data)
        }
    }, [data])

    async function Update() {
        const update_exercicio = {
            'idFuncao': values.idFuncao,
            "userIdExercicio": user_exercicio
        }
        api.put(`/funcoes`, { update_exercicio })
            .then(() => {
                setReload(currentIsOpen => !currentIsOpen)
                setOpen(false)
                snack.current("Usuário editado!", { variant: 'success' })
            })
            .catch((error) => {
                if (error?.response?.data?.message) {
                    snack.current(`${error.response.data.message}`, { variant: 'error' })
                } else {
                    snack.current("Falha ao adicionar o usuário!", { variant: 'error' })
                }
            });
    }

    return (
        <>
            <DialogContent className={classes.root}>
                <Exercicio values={values} responsaveis={responsaveis} setUserExercio={setUserExercio} setValues={setValues} />
                <CreatedBy values={values} />
            </DialogContent >
            <DialogActions>
                <Button
                    onClick={() => Update()}
                    disabled={
                        responsaveis.length === 0 ||
                            values.exercicio === ""
                            ? true : false
                    }
                >
                    Salvar
                </Button>
                <Button onClick={() => setOpen(false)}>
                    Cancelar
                </Button>
            </DialogActions>
        </>
    )
}

FormStore.propTypes = {
    setOpen: PropTypes.func,
    setReload: PropTypes.func
};
